import React from 'react';
import { ControlledLabelledCheckBox as CheckBox } from '@zz2/zz2-ui';
import { Control } from 'react-hook-form';
import {
    getSelectedThemeLocalStorage,
} from '../../../services/localStorageService';
import { CustomChangeEvent } from '../../../@types/helper';

interface IControlledLabelledCheckBoxProps {
    name : string;
    label : string;
    control : Control<any, any>;
    defaultValue : boolean;
    className ?: string;
    disabled ?: boolean;
    onChange ?: (e : CustomChangeEvent, checked : boolean) => void;
}

export const ControlledLabelledCheckBox = (props : IControlledLabelledCheckBoxProps) => {
    const selectedTheme = getSelectedThemeLocalStorage();
    const { className, ...rest } = props;
    return <CheckBox
        className={`${selectedTheme === 'Dark' ? 'cw' : 'cpd'} p0 ${className}`}
        {...rest}
    />;
};
